// extracted by mini-css-extract-plugin
export default {"orderDetails":"OderCard_orderDetails__671LK","inner_container":"OderCard_inner_container__95h2X","product":"OderCard_product__4yuIA","productImg":"OderCard_productImg__Ff6xs"};